module.exports = __webpack_public_path__ + "refresh-icon.3e6c7b89661ae9064626.svg";


//////////////////
// WEBPACK FOOTER
// /home/maheshreddy/PRP_FE/src/img/icon/refresh-icon.svg
// module id = ../../../../../src/img/icon/refresh-icon.svg
// module chunks = styles